const setupLogMessages = {
    addressType: 'un tipo de dirección',
    department: 'un departamento',
    salesOrg: 'una organización de ventas',
    conditionalOrg: 'una organización condicional',
    depositOrg: 'una organización de depósito',
    zone: 'una zona',
    procedureFamily: 'una familia de procedimientos',
    family: 'una familia',
    subFamily: 'una subfamilia',
    incidenceType: 'un tipo de incidencia',
    loanType: 'un tipo de préstamo',
    brand: 'una marca',
    model: 'un modelo'
}

const globalLogMessages = {
    mailer: 'un mensaje'
}

export const logMessages = {
    mutua: 'una mutua',
    center: 'un centro',
    doctor: 'un doctor',
    procedure: 'un procedimiento',
    surgery: 'una cirugía',
    notification: 'una notificación',
    alert: 'una alerta',
    vehicle: 'un vehículo',
    calendar: 'un calendario',
    route: 'una ruta',
    user: 'un usuario',
    role: 'un rol',
    log: 'un log',
    uploadFile: 'un archivo',
    uploadImage: 'una imagen',
    incidence: 'una incidencia',
    Materials: 'un material',
    Instruments: 'un instrumento',
    InstrumentTypes: 'un tipo de instrumento',
    instrumental: 'un instrumental',
    sheet: 'una ficha',
    loan: 'una préstamo',
    deposit: 'un depósito',
    sale: 'una venta',
    delivery: 'un albarán',
    deliveryTime: 'un horario de entrega',
    lot: 'un lote',
    Pallets: 'un empaquetado',
    transporter: 'un transportista',
    ...setupLogMessages,
    ...globalLogMessages
}